import React from "react";
import { Form, Label } from "semantic-ui-react";
import AccessibleCheckbox from "../../../../../../components/global_components/AccessibleCheckbox";

interface FilterGroupsProps {
  groupLabel: string;
  groups: { id: number; name: string }[] | undefined;
  selectedGroups: number[];
  onSelectAll: (checked: boolean) => void;
  onGroupChange: (groupId: number, checked: boolean) => void;
}

const SubscriptionGroupsFilter: React.FC<FilterGroupsProps> = ({
  groupLabel,
  groups,
  selectedGroups,
  onSelectAll,
  onGroupChange,
}) => {
  const allSelected = groups?.every((group) => selectedGroups.includes(group.id));

  return (
    <Form.Field>
      <Label className='tw-bg-transparent tw-pl-0 tw-text-base tw-font-bold tw-text-black'>{groupLabel}</Label>
      <AccessibleCheckbox
        key={`SelectAll-${groupLabel}`}
        label='Select All'
        checked={allSelected}
        onChange={(checked) => onSelectAll(checked)}
      />
      {groups?.map((group) => (
        <AccessibleCheckbox
          key={group.id}
          label={group.name}
          checked={selectedGroups.includes(group.id)}
          onChange={(checked) => onGroupChange(group.id, checked)}
        />
      ))}
    </Form.Field>
  );
};

export default SubscriptionGroupsFilter;
